import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Grid2, Typography } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import { FormFiltersInterface } from "../interfaces/FormFiltersInterface"
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputSwitch from '../../../../components/inputs/yup/materialui/inputSwitch';
import { selectorTransversal } from "../../../../dtos/selector";
import { AxiosResponse } from "axios";
import { getEmisor } from "../../../reportes/generarProcesosMasivos/service/servicePM";
import { StatusCode } from "../../../../utils/enums";
import validaRut from "../../../../utils/validaRut";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { Emisor } from "../../../reportes/generarProcesosMasivos/models/generarArchivoProcesosMasivos";

const actualYear = new Date().getFullYear();

const validationSchema: yup.ObjectSchema<FormFiltersInterface> = yup.object({
  rutDeudor: yup
    .string()
    .nullable()
    .test("valida-rut", "RUT inválido", function (value) {
      if (!value) return true; // si está vacío o null, no valida
      return validaRut.rutFormat(value);
    })
    .max(12, "Máximo 12 caractéres"),
  nombreDeudor: yup.string().nullable().max(60, 'Máximo 60 caractéres'),
  numeroOperacion: yup.string().nullable(),
  rutEmisor: yup.string().nullable(),
  isAdmin: yup.boolean().required(),
});

interface FiltrosComponentProps {
  handleFilter: (formFilters: FormFiltersInterface) => void;
}

export const FiltrosComponent = ({ handleFilter }: FiltrosComponentProps) => {
  
  const [optionsEmisor, setOptionsEmisor] = useState<selectorTransversal[]>([]);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormFiltersInterface>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      isAdmin: true,
      rutEmisor: '0',
      numeroOperacion: actualYear.toString(),
    },
  });

  
  const onSubmit = (form: FormFiltersInterface) => handleFilter(form);

  const obtenerEmisores = async () => {
    const resp: AxiosResponse<ListResponseDto<Emisor>> = await getEmisor()
    if (resp.status === StatusCode.Ok) {
      const data: Emisor[] = await resp.data.items;
      const options = data.map((m: any) => ({
          label: m.nombre,
          value: m.rut,
      })); setOptionsEmisor([{ label: "Todos", value: "0" }, ...options]);
    }
    return
  }

  useEffect(() => {
    const inicializar = async () => {
      await obtenerEmisores();
    };

    inicializar();
  }, []);

  return (
    <CustomAccordion title="Filtros" expandedDefault>
      <form onSubmit={handleSubmit(onSubmit)}>

        <Grid2 container spacing={2} sx={{ 
          marginTop: 1,
          alignItems: "center",
        }}>

          <Grid2 size={4}>
            <InputText name="numeroOperacion" control={control} label="N° de Operación" />
            <Typography color="error">{errors.numeroOperacion?.message}</Typography>
          </Grid2> 

          <Grid2 size={4}>
            <InputRut
              name="rutDeudor"
              control={control}
              label="RUT deudor"
              error={errors.rutDeudor}
            />
          </Grid2>    

          <Grid2 size={4}>
            <InputText name="nombreDeudor" control={control} label="Nombre" />
            <Typography color="error">{errors.nombreDeudor?.message}</Typography>
          </Grid2> 

          <Grid2 size={3}>
            <InputSelect
              clearable={false}
              name="rutEmisor"
              control={control}
              label="Emisor"
              options={optionsEmisor}
              error={errors.rutEmisor}
            />
            <Typography color="error">{errors.rutEmisor?.message}</Typography>
          </Grid2> 

          <Grid2 size={3} sx={{ marginLeft: 10, marginTop: 3 }}>
            <InputSwitch
              label={"Es administrado"}
              name="isAdmin"
              control={control}
              error={errors.isAdmin}
            />
          </Grid2> 

        </Grid2>

        {/* Contenedor del Botón */}
        <Grid2 size={{ xs: 8 }} sx={{ 
          marginTop: '10px',
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}>
          <MButton
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<FilterListIcon />}
            sx={{ 
              height: "40px", 
              whiteSpace: "nowrap",
              px: 3
            }}
          >
            Filtrar
          </MButton>
        </Grid2>
      </form>
    </CustomAccordion>
  );
};